import { ArrowDownIcon, ArrowUpIcon } from '@heroicons/react/solid';

export const TREND_COLORS = {
  up: 'rgb(2, 122, 72)',
  down: 'rgb(180, 35, 24)',
  unchanged: 'rgb(2, 122, 72)',
} as const;

export const TREND_ICONS = {
  up: ArrowUpIcon,
  down: ArrowDownIcon,
} as const;

interface FontConfig {
  base: number;
  min: number;
  max: number;
  scale: number;
}

interface FontConfigs {
  main: FontConfig;
  comparison: FontConfig;
  bottomLabel: FontConfig;
}

export const FONT_CONFIG: FontConfigs = {
  main: {
    base: 32,
    min: 0.8,
    max: 2,
    scale: 1,
  },
  comparison: {
    base: 12,
    min: 1, // This ensures minimum stays at 12px
    max: 1.5,
    scale: 0.7,
  },
  bottomLabel: {
    base: 14,
    min: 0.8,
    max: 1.5,
    scale: 0.7,
  },
};
